import React from 'react';
import styled from 'styled-components';

import {
  NURSE_LINK_BASE_URL,
  NURSEEDU_BASE_URL,
  NURSEEDU_COMMUNITY_BASE_URL,
} from 'src/app.core/nurseEdu/constant/nurseEduConfig';

interface Props {
  colorsOverride?: {
    primary?: string;
    linkDefault?: string;
    divider?: string;
  };
  active?: 'nurselink' | 'nurseEdu' | 'community';
}

export const HeaderNavLinks = ({ colorsOverride, active = 'nurselink' }: Props) => {
  const primary = colorsOverride?.primary ?? '#38459F';
  const linkDefault = colorsOverride?.linkDefault ?? '#626262';
  const dividerColor = colorsOverride?.divider ?? '#BEBEBE';

  return (
    <NavWrapper>
      <NavLink
        href={NURSE_LINK_BASE_URL}
        $isActive={active === 'nurselink'}
        $activeColor={primary}
        $defaultColor={linkDefault}
      >
        널스링크
      </NavLink>
      <Divider $color={dividerColor} />
      <NavLink
        href={NURSEEDU_BASE_URL}
        $isActive={active === 'nurseEdu'}
        $activeColor={primary}
        $defaultColor={linkDefault}
      >
        널스에듀
      </NavLink>
      <Divider $color={dividerColor} />
      <NavLink
        href={NURSEEDU_COMMUNITY_BASE_URL}
        $isActive={active === 'community'}
        $activeColor={primary}
        $defaultColor={linkDefault}
      >
        커뮤니티
      </NavLink>
    </NavWrapper>
  );
};

const NavWrapper = styled.nav`
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 20px;

  @media (max-width: 768px) {
    display: none;
  }
`;

const NavLink = styled.a<{
  $isActive: boolean;
  $activeColor: string;
  $defaultColor: string;
}>`
  padding: 6px 8px;
  font-weight: ${({ $isActive }) => ($isActive ? 700 : 400)};
  color: ${({ $isActive, $activeColor, $defaultColor }) =>
    $isActive ? $activeColor : $defaultColor};

  line-height: 140%;
  letter-spacing: -0.02em;
`;

const Divider = styled.div<{ $color: string }>`
  width: 1px;
  height: 12px;
  margin: 14px 4px;
  background-color: ${({ $color }) => $color};
`;
